'use client';
import React, { type FC, JSX, memo, useState } from 'react';
import styles from './index.module.scss';

const ContactSection: FC = (): JSX.Element => {
  // const apiKey = process.env.FORMSUBMIT_API_KEY;
  // TODO: ask zino why this is not working
  const apiKey =
    typeof window !== 'undefined' ? process.env.FORMSUBMIT_API_KEY : '';

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const isFormFilled = name && email && message;
  return (
    <div className={styles.container}>
      <p>
        Looking for artwork, commissions, or collaborations? Get in touch via
        the form below, email, or Instagram.
        <br />
        <br />
        📧 Email:{' '}
        <a href="mailto:oudealinkkaren@gmail.com">oudealinkkaren@gmail.com</a>
        <br />
        📷 Instagram:{' '}
        <a
          href="https://www.instagram.com/accounts/login/?next=https%3A%2F%2Fwww.instagram.com%2Fkarenoudealink%2F%3Figsh%3DdXB4NW1ucWE2MXp6&is_from_rle"
          target="_blank"
          rel="noopener noreferrer"
        >
          karenoudealink
        </a>
      </p>
      <form
        target="_blank"
        action={`https://formsubmit.co/fa485b8b6594e15d81831bd7e033ff92`}
        method="POST"
        className={styles.form}
      >
        <input
          type="text"
          name="name"
          placeholder="Name"
          required
          onChange={(e) => setName(e.target.value)}
        />
        <input
          type="email"
          name="email"
          placeholder="Your Email Address"
          required
          onChange={(e) => setEmail(e.target.value)}
        />
        <textarea
          placeholder="Your Message"
          name="message"
          rows={5}
          required
          onChange={(e) => setMessage(e.target.value)}
        ></textarea>
        {isFormFilled && <button>Submit</button>}
      </form>
    </div>
  );
};

export default memo(ContactSection);
